import React from 'react'
import FranceBloreMain from './FranceBloreMain'
import "./../../UaeAttestation/UaeBlore/UaeBlore.css";
import UaeBloreHead from '../../UaeAttestation/UaeBlore/UaeBloreHead';
const FranceBlore = () => {
  return (
    <div className="uaeBloreContainer">
    <UaeBloreHead head="France Apostille in Bangalore" />
    <FranceBloreMain />
  </div>
  )
}

export default FranceBlore
